import { render, staticRenderFns } from "./QuantJyJyPool.vue?vue&type=template&id=67852828"
import script from "./QuantJyJyPool.vue?vue&type=script&lang=js"
export * from "./QuantJyJyPool.vue?vue&type=script&lang=js"
import style0 from "./QuantJyJyPool.vue?vue&type=style&index=0&id=67852828&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports